// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"382":"4185d8b1","661":"f66bcf1a","968":"b64def07"}[chunkId] + ".chunk.js";
};